<template>
	<div v-if="canShow" class="SuggestionContainer" @click="apply()">
		<Tag :tag="suggestion.tag" :icon="suggestion.tagIcon" :trackingPayload="suggestion.trackingPayload" :trackClick="true" ref="tagRef"/>
		<span class="ShowResults" @click="apply($event)">Show {{count}} {{count === 1 ? 'result' : 'results'}}</span>
	</div>
</template>

<script lang="ts" src="./SelectionSuggestion.ts"></script>
<style lang="scss" src="./SelectionSuggestion.scss" scoped></style>
